export interface AdequacyOption {
    id: number;
    name: 'Adequate' | 'Questionable' | 'Inadequate';
    level: number;
}

export const ADEQUACY_OPTIONS: AdequacyOption[] = [
    { id: 1, name: 'Adequate', level: 1 },
    { id: 2, name: 'Questionable', level: 2 },
    { id: 3, name: 'Inadequate', level: 3 }
];
